import { NiceSimRegistrationImpl } from "features/niceSimRegistration/data/NiceSimRegistrationImpl";
import { INiceSimRegistrationRepository } from "features/niceSimRegistration/domain/repositories/INiceSimRegistrationRepository";
import { NiceSimRegistrationUseCase } from "features/niceSimRegistration/domain/useCases/NiceSimRegistrationUseCase";
import { NiceSimRegistrationViewModel } from "features/niceSimRegistration/presentation/viewModel/NiceSimRegistrationViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class NiceSimRegistrationInjection extends InjectionModule {
  private static readonly niceSimRegistrationRepositoryToken = Symbol(
    "INiceSimRegistrationRepository",
  );
  private static readonly niceSimRegistrationViewModelToken = Symbol(
    "NiceSimRegistrationViewModel",
  );
  private static readonly niceSimRegistrationUseCaseToken = Symbol(
    "NiceSimRegistrationUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.niceSimRegistrationRepositoryToken,
      useClass: NiceSimRegistrationImpl,
    },
    {
      scope: "otherRepo",
      token: this.niceSimRegistrationUseCaseToken,
      useClass: NiceSimRegistrationUseCase,
    },
    {
      scope: "viewModel",
      token: this.niceSimRegistrationViewModelToken,
      useClass: NiceSimRegistrationViewModel,
    },
  ];

  static getNiceSimRegistrationRepo(): INiceSimRegistrationRepository {
    return this.resolve(this.niceSimRegistrationRepositoryToken);
  }

  static getNiceSimRegistrationUseCase(): NiceSimRegistrationUseCase {
    return this.resolve(this.niceSimRegistrationUseCaseToken);
  }
}
